import React, { Component } from 'react';
import { connect } from 'react-redux';
import spanish from '../../../../../common/language/spanis';
import english from '../../../../../common/language/english';
import './styles.css';
import Grid from '@material-ui/core/Grid';
import bed from '../../../../../assets/resorts/bed.png';
import bath from '../../../../../assets/resorts/bath.png';
import kid from '../../../../../assets/resorts/kid.png';
import adult from '../../../../../assets/resorts/adult.png';
import room from '../../../../../assets/resorts/hotel.png';
import layout from '../../../../../common/layout';
import ModalForm from './book/modal';
import {ResortsActions} from '../../../../../redux/resorts';

class Rooms extends Component {
    constructor() {
        super();
        this.state = {
            roomsList: null,
            lan: null,
            open: false
        }
    }
    componentDidMount() {
        const { language } = this.props;
        if (language === 'spanish') {
            this.setState({ lan: spanish });
        }
        else {
            this.setState({ lan: english });

        }
    }

    componentWillReceiveProps(next) {
        console.log(next)
        this.setState({ roomsList: next.rooms });
    }

    handleOpen = () => {
        this.setState({ open: true })
        // this.props.setCurrentReservationType('cruiser');
      }
    
      handleClose = () => {
        this.setState({ open: false })
      }

    renderRooms = (roomsList) => {
        // DESTRUCTURING
        const { lan } = this.state;
        const { currentPlace } = this.props;
        var currentrooms = [];
        // MAP ROOMS AVAILABLES
        roomsList.map((item, key) => {
            if (item.citiesAvailable.find((city) => city === currentPlace.id)&&!item.discard) {
               currentrooms.push(item);
            }
        })
        // MAP ROOMS LIST
        return currentrooms.map((item,key)=>{
            return (
                <div className="containerRoom" key={key}>
                    <div className="itemRoom cont1" style={{ order: key % 2 === 0 ? 1 : 2 }}>
                        <div className="itemRoomImg" style={{backgroundImage: `url(${item.img})` }}>

                        </div>
                    </div>
                    <div className="itemRoom cont2" style={{ order: key % 2 === 0 ? 2 : 1 }}>
                        <div style={{ padding: 20 }}>
                            <h4>{lan.lan == 'spanish' ? item.information.spanish.name : item.information.english.name}</h4>
                            <p className="roomDescription">{lan.lan == 'spanish' ? item.information.spanish.description : item.information.english.description}</p>



                            {/* OCCUPANTS */}
                            <Grid
                                container
                                direction="row"
                            >
                                <Grid item key={key} lg={6} xs={6} >
                                    <p>
                                        <span>
                                            <img src={room} width={20} style={{ marginRight: 5 }} />
                                        </span>
                                        <span style={{ fontSize: 12, color: '#6B6B6B' }}>
                                            {lan.lan == 'spanish' ? item.information.spanish.type : item.information.english.type}
                                        </span>
                                    </p>
                                </Grid>
                                <Grid item key={key} lg={6} xs={6} >
                                    <p>
                                        <span>
                                            <img src={bed} width={20} style={{ marginRight: 5 }} />
                                        </span>
                                        <span style={{ fontSize: 12, color: '#6B6B6B' }}>
                                            {lan.lan == 'spanish' ? item.information.spanish.bed : item.information.english.bed}
                                        </span>
                                    </p>
                                </Grid>
                                <Grid item key={key} lg={6} xs={6} >
                                    <p>
                                        <span>
                                            <img src={bath} width={20} style={{ marginRight: 5 }} />
                                        </span>
                                        <span style={{ fontSize: 12, color: '#6B6B6B' }}>
                                            {lan.lan == 'spanish' ? item.information.spanish.bathroom : item.information.english.bathroom}
                                        </span>
                                    </p>
                                </Grid>
                                <Grid item key={key} lg={6} xs={6}  >
                                    <p><img src={adult} width={20} style={{ marginRight: 5 }} /> <span className="badge">{item.information.occupants.adults}</span><img src={kid} width={20} style={{ marginRight: 5, marginLeft: 15 }} /> <span className="badge">{item.information.occupants.kids}</span></p>


                                </Grid>

                            </Grid>
                            {/* PRICES */}
                            <Grid container direction="row">
                                <Grid item key={key} lg={6} xs={6} >
                                    <strong>{lan.rooms.nightPrice} :</strong>
                                    <p style={{color:'red', textDecoration:'line-through'}} >{lan.lan == 'spanish' ? item.information.spanish.price.night : item.information.english.price.night}</p>
                                </Grid>
                                <Grid item key={key} lg={6} xs={6} >
                                    <strong>{lan.rooms.weekPrice}  : </strong>
                                    <p>{lan.lan == 'spanish' ? item.information.spanish.price.week : item.information.english.price.week}</p>
                                </Grid>
                            </Grid>

                            {/* RESERVE */}
                            <div className="buttonR" style={{ backgroundColor: layout.gold }} onClick={()=>{
                                this.handleOpen();
                                var currentRoom = lan.lan == 'spanish' ? item.information.spanish.name : item.information.english.name;
                                this.props.setCurrentRoomAction(currentRoom)
                                }}>
                                <p className="reserveButton">{lan.rooms.reserve}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })

    }

    render() {
        const { roomsList, open } = this.state;
        const { currentPlace } = this.props;
        return (
            <div style={{ padding: 20 }}>
                {roomsList && currentPlace && this.renderRooms(roomsList)}
                <ModalForm
                open={open}
                handleClose={this.handleClose}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    places: state.ResortsReducer.places,
    currentPlace: state.ResortsReducer.currentPlace,
    rooms: state.ResortsReducer.rooms,
    language: state.LanguageReducer.language
});

const mapDispatchToProps = dispatch => ({
    setCurrentRoomAction: (currentRoom) => {
        dispatch(ResortsActions.setCurrentRoom(currentRoom));
    },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Rooms);
